import {
  audioContentTypes,
  audioExtensions,
  docExtensions,
  imageExtensions,
  videoContentTypes,
  videoExtensions,
} from '@shared/constants/files-extensions'
import regExp from '@shared/utils/helpers/regular-expressions'

export const isImage = (contentType?: string, url?: string) =>
  contentType?.startsWith('image') ||
  imageExtensions.some((extension) =>
    url?.toLowerCase()?.endsWith(`.${extension}`)
  )

export const isVideo = (contentType?: string, url?: string) => {
  return (
    ((contentType?.includes('video') &&
      videoContentTypes.some((ext) => contentType.includes(ext))) ||
      videoExtensions.some((extension) =>
        url?.toLowerCase()?.endsWith(`.${extension}`)
      )) &&
    !url?.toLowerCase().endsWith('.m4a')
  )
}

export const isPdf = (contentType?: string, url?: string) =>
  Boolean(contentType?.includes('pdf') || url?.endsWith('.pdf'))

export const isDocx = (contentType?: string, url?: string) =>
  contentType?.includes('msword') || // Check for MS Word MIME type
  contentType?.includes('officedocument') || // For newer MS Office documents
  contentType?.includes('rtf') || // For RTF files
  contentType?.includes('pptx') ||
  contentType?.includes('xlsx') ||
  docExtensions.some((extension) =>
    url?.toLowerCase()?.endsWith(`.${extension}`)
  )

export const isAudio = (contentType?: string, url?: string) => {
  return !!(
    contentType?.includes('audio') &&
    (audioContentTypes.some((ext) => contentType?.includes(ext)) ||
      audioExtensions.some((extension) =>
        url?.toLowerCase()?.endsWith(`.${extension}`)
      ))
  )
}

export const isXml = (contentType?: string, url?: string) =>
  contentType?.includes('xml') || url?.toLowerCase()?.endsWith('.xml')

export const isRtf = (contentType?: string, url?: string) =>
  contentType?.includes('rtf') || url?.toLowerCase()?.endsWith('.rtf')

export const isJson = (contentType?: string, url?: string) =>
  contentType?.includes('json') || url?.toLowerCase()?.endsWith('.json')

export const isCsv = (contentType?: string, url?: string) =>
  !!contentType?.match(regExp.csvFile) ||
  ['csv'].some((extension) => url?.toLowerCase()?.endsWith(`.${extension}`))

export const isXls = (contentType?: string, url?: string) =>
  !!contentType?.match(regExp.xlsFile) ||
  ['xls', 'xlsx'].some((extension) =>
    url?.toLowerCase().endsWith(`.${extension}`)
  )

export const isZip = (contentType?: string, url?: string) =>
  !!contentType?.match(regExp.zipFile) ||
  ['zip', 'rar', 'tar', 'gz'].some((extension) =>
    url?.toLowerCase()?.endsWith(`.${extension}`)
  )
